var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ruleBox"},[_c('navBar',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"content-box font26"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.dataList.content)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }